<!-- Print Attendance Dialog -->
<!-- <div mat-dialog-title class="dialog-header">
  <h1>Print Attendance Sheet</h1>
  <button mat-button mat-dialog-close class="close-button-dialog">
    <mat-icon aria-hidden="false" aria-label="Close dialog">close</mat-icon>
  </button>
</div> -->

<div mat-dialog-content class="dialog-content">
  <div class="print-attendance-container" [attr.data-component-id]="componentId">
    <!-- Header Section -->
    <div class="attendance-header">
      <!-- Agenda Master Logo - Centered -->
      <div class="agenda-master-logo-section">
        <img [src]="agendaMasterLogo" alt="Agenda Master" class="agenda-master-logo">
      </div>

      <div class="header-content">
        <div class="logo-section" *ngIf="studioLogo">
          <img [src]="studioLogo" [alt]="studioName + ' Logo'" class="studio-logo">
        </div>
        <div class="title-section">
          <h1 class="studio-name">{{ studioName }}</h1>
          <p class="studio-address" *ngIf="studioAddress">{{ studioAddress }}</p>
          <h2 class="attendance-title">Daily Attendance Sheet</h2>
          <p class="attendance-date">{{ formattedDate }}</p>
        </div>
      </div>
    </div>

  <!-- No Events Message -->
  <div *ngIf="attendanceGroups.length === 0" class="no-events">
    <p>No lessons or appointments scheduled for this date.</p>
  </div>

  <!-- Single Attendance Table -->
  <table class="attendance-table">
    <thead>
      <tr>
        <th class="time-col">Time</th>
        <th class="student-col">Student Name</th>
        <th class="instructor-col">Instructor</th>
        <th class="type-col">Type</th>
        <th class="duration-col">Duration</th>
        <th class="signature-col">Student Signature</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let group of attendanceGroups">
        <tr *ngFor="let event of group.events" class="attendance-row">
          <td class="time-cell">
            {{ formatTime(event.start) }}
          </td>
          <td class="student-cell">
            {{ event.studentName }}
          </td>
          <td class="instructor-cell">
            {{ event.instructorName }}
          </td>
          <td class="type-cell">
            <span [ngClass]="'type-' + event.appointmentType">
              {{ formatEventType(event.appointmentType) }}
            </span>
          </td>
          <td class="duration-cell">
            {{ formatDuration(event.start, event.end) }}
          </td>
          <td class="signature-cell">
            <div class="signature-line"></div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <!-- Footer Section -->
  <div class="attendance-footer">
    <div class="footer-notes">
      <p><strong>Notes:</strong></p>
      <div class="notes-area">
        <div class="note-line"></div>
        <div class="note-line"></div>
        <div class="note-line"></div>
      </div>
    </div>
  </div>

    <!-- Print Button (hidden when printing) -->
    <div class="print-controls no-print">
      <button style="background-color: transparent !important; border: none;"
        (click)="print()"
        type="button"
        mat-icon-button
        class="mb-1"
        matTooltip="Print attendance sheet"
        matTooltipPosition="below"
        aria-label="Print attendance sheet">
        <mat-icon style="color: #1C3F8B;">print</mat-icon>
      </button>
      <button mat-button color="warn" (click)="closeView()" class="close-button">
        <mat-icon>close</mat-icon>
        Close Print View
      </button>
    </div>
  </div>
</div>
